import { useMemo } from 'react';
import createIntl from '../core/use-intl.esm4.js';
import useIntlContext from './use-intl.esm10.js';

var hasWarned = false;
/** @deprecated Switch to `useFormatter` instead. */
function useIntl() {
  var _useIntlContext = useIntlContext(),
    formats = _useIntlContext.formats,
    locale = _useIntlContext.locale,
    globalNow = _useIntlContext.now,
    onError = _useIntlContext.onError,
    timeZone = _useIntlContext.timeZone;
  if (!hasWarned) {
    hasWarned = true;
    console.warn('`useIntl()` is deprecated and will be removed in the next major version. Please switch to `useFormatter()`.');
  }
  return useMemo(function () {
    return createIntl({
      formats: formats,
      locale: locale,
      now: globalNow,
      onError: onError,
      timeZone: timeZone
    });
  }, [formats, globalNow, locale, onError, timeZone]);
}

export { useIntl as default };
//# sourceMappingURL=use-intl.esm7.js.map
